// import React, { useRef, useEffect } from 'react';
// import H from '@here/maps-api-for-javascript';
// import { Box } from '@mui/material';
// import start_mark from '../../assets/images/icons/marker/start_mark.svg';
// import end_mark from '../../assets/images/icons/marker/end_mark.svg';
// import noDataFound from '../../assets/images/nothing-found.svg';
// import { routeMap } from 'utilities/common';

// const CalculateMap = ({ route,  taskAddress, showImg }) => {
//   const mapRef = useRef(null); // Reference to the DOM element for the map
//   const platform = useRef(null); // Reference to the HERE Maps platform
//   const mapInstance = useRef(null); // Reference to the map instance

//   // Map routeMap points to the format required by HERE Maps
//   useEffect(() => {
//     if (!routeMap || routeMap?.length === 0) {
//       return;
//     }

//     const updatedPoints = routeMap?.map(point => ({
//       lat: point.latitude,
//       lng: point.longitude
//     }));

//     const addressEndFlag = {
//       'lat': taskAddress?.latitude,
//       'lng': taskAddress?.longitude
//     };

//     const apikey = process.env.REACT_APP_MAP_KEY; // API key for HERE Maps
//     platform.current = new H.service.Platform({ apikey }); // Initialize the HERE Maps platform

//     // Set up raster tile service with specified parameters
//     const rasterTileService = platform.current.getRasterTileService({
//       queryParams: {
//         style: 'logistics.night',
//         features: 'vehicle_restrictions:active_and_inactive,pois:disabled',
//         size: 512
//       }
//     });

//     // Create raster tile layer
//     const rasterTileProvider = new H.service.rasterTile.Provider(rasterTileService);
//     const rasterTileLayer = new H.map.layer.TileLayer(rasterTileProvider);

//     // Initialize the map instance
//     const defaultLayers = platform.current.createDefaultLayers();
//     mapInstance.current = new H.Map(mapRef.current, rasterTileLayer, {
//       zoom: 10,
//       center: { lat: updatedPoints[0].lat, lng: updatedPoints[0].lng },
//       pixelRatio: window.devicePixelRatio || 1
//     });

//     const ui = H.ui.UI.createDefault(mapInstance.current, defaultLayers);
//     ui.removeControl('mapsettings'); // Remove the map settings control

//     // Function to cluster waypoints into groups for routing
//     const clusterWaypoints = (points) => {
//       const maxClusterSize = 50;// Max size of each cluster
//       const clusters = [];

//       for (let i = 0; i < points.length; i += maxClusterSize) {
//         clusters.push(points.slice(i, i + maxClusterSize));// Group points into clusters
//       }
//       return clusters;// Return the clustered points
//     };

//     // Cluster the updated points
//     const clusters = clusterWaypoints(updatedPoints);

//     // Function to handle the routing result
//     const onResult = (result) => {
//       if (result.routes.length) {
//         const lineStrings = [];
//         // Extract polyline from route sections
//         result.routes[0].sections.forEach((section) => {
//           lineStrings.push(H.geo.LineString.fromFlexiblePolyline(section.polyline));
//         });

//         const multiLineString = new H.geo.MultiLineString(lineStrings);// Create MultiLineString
//         const routeLine = new H.map.Polyline(multiLineString, {
//           style: { strokeColor: '#FFE37E', lineWidth: 3 } // Style for the route line
//         });
//         const group = new H.map.Group(); // Create a group for map objects
//         group.addObjects([routeLine]);// Add route line to the group

//         // Function to create a custom icon for markers
//         const createCustomIcon = (iconUrl) => {
//           return new H.map.Icon(iconUrl, { size: { w: 24, h: 24 } });
//         };

//         // Create start and end markers
//         const startMarker = new H.map.Marker(updatedPoints[0], { icon: createCustomIcon(start_mark) });
//         const endMarker = new H.map.Marker(addressEndFlag, { icon: createCustomIcon(end_mark) });

//         group.addObjects([startMarker, endMarker]);// Add markers to the group

//         // Add the group to the map and adjust the view
//         mapInstance.current.addObject(group);
//         mapInstance.current.getViewModel().setLookAtData({
//           bounds: group.getBoundingBox(),// Adjust the view to fit the markers
//         });
//       }
//     };
//     // Initialize the HERE Routing Service
//     const router = platform.current.getRoutingService(null, 8);

//     // Calculate route for each cluster of waypoints
//     clusters.forEach(cluster => {
//       const origin = cluster[0];
//       const routingParameters = {
//         routingMode: 'fast',
//         transportMode: 'car',
//         origin: `${origin.lat},${origin.lng}`,
//         destination: `${taskAddress?.latitude},${taskAddress?.longitude}`,

//         return: 'polyline',
//         via: new H.service.Url.MultiValueQueryParameter(
//           cluster.map(wp => `${wp.lat},${wp.lng}`)
//         )
//       };

//       // Calculate the route and handle the result
//       router.calculateRoute(routingParameters, onResult, (error) => {
//         alert(error.message);
//       });
//     });

//     // Add event handling for map interactions
//     new H.mapevents.Behavior(new H.mapevents.MapEvents(mapInstance.current));
//     window.addEventListener('resize', () => mapInstance.current.getViewPort().resize()); // Adjust map on resize

//     // Cleanup event listener on component unmount
//     return () => {
//       window.removeEventListener('resize', () => mapInstance.current.getViewPort().resize());
//     };
//   }, [routeMap]); // Effect runs when routeMap changes

//   return (
//     <>
//       {
//         routeMap?.length === 0 ?
//           <div className='d-flex align-item-center flex-column gap-3 jc-center p-4'>
//             {!showImg && <Box textAlign='center' className='no-data-found'>
//               <img style={{ maxWidth: '120px' }} src={noDataFound} alt='No Route Found' />
//               <p className='text-12'><strong>No Route Found</strong></p>
//             </Box>}
//           </div> :
//           <>
//             <div style={{ position: 'relative', width: '100%', height: '100%', borderRadius: '6px', overflow: 'hidden' }}>
//               {(routeMap?.length === 0 || routeMap === undefined) ? '' : <div ref={mapRef} style={{ width: '100%', height: route === 'detailRoute' ? '200px' : route === 'taskRoute' ? '500px' : '300px' }}></div>}
//             </div>
//           </>
//       }
//     </>
//   );
// };

// export default CalculateMap;
// *********************************************************************************************************map box**********************************************************

// import React, { useRef, useEffect } from 'react';
// import mapboxgl from 'mapbox-gl';
// import 'mapbox-gl/dist/mapbox-gl.css';
// import { Box } from '@mui/material';
// import start_mark from '../../assets/images/icons/marker/start_mark.svg';
// import end_mark from '../../assets/images/icons/marker/end_mark.svg';
// import noDataFound from '../../assets/images/nothing-found.svg';
// // import { routeMap } from 'utilities/common';

// // Set your Mapbox access token
// mapboxgl.accessToken =  process.env.REACT_APP_MAP_KEY_TOKEN;

// const CalculateMap = ({ route, taskAddress, showImg,routeMap }) => {
//   const mapRef = useRef(null);
//   const mapContainerRef = useRef(null);
//   const markersRef = useRef([]);
//   const routeLinesRef = useRef([]);


//   useEffect(() => {
//     if (!routeMap || routeMap?.length === 0) {
//       return;
//     }

//     const updatedPoints = routeMap?.map(point => ({
//       lat: point.latitude,
//       lng: point.longitude
//     }));


//     const addressEndFlag = {
//       lat: taskAddress?.latitude,
//       lng: taskAddress?.longitude
//     };

//     // Initialize the map
//     const map = new mapboxgl.Map({
//       container: mapContainerRef.current,
//       style: 'mapbox://styles/mapbox/dark-v10',
//       center: [updatedPoints[0].lng, updatedPoints[0].lat],
//       zoom: 10
//     });

//     mapRef.current = map;

//     // Add navigation controls
//     map.addControl(new mapboxgl.NavigationControl());

//     // Your original clusterWaypoints function
//     const clusterWaypoints = (points) => {
//       const maxClusterSize = 50;
//       const clusters = [];
//       for (let i = 0; i < points.length; i += maxClusterSize) {
//         clusters.push(points.slice(i, i + maxClusterSize));
//       }
//       return clusters;
//     };
// // Function to create route using Map Matching API
// const createRoute = async (points) => {
//   try {
//     // Ensure the last point is addressEndFlag
//     const routePoints = [...points];
//     if (routePoints[routePoints.length - 1] !== addressEndFlag) {
//       routePoints.push(addressEndFlag);
//     }

//     const coordinates = routePoints.map(point => [point.lng, point.lat]).join(';');

//     const response = await fetch(
//       `https://api.mapbox.com/matching/v5/mapbox/driving/${coordinates}?geometries=geojson&access_token=${mapboxgl.accessToken}`
//     );

//     const data = await response.json();

//     if (data.matchings && data.matchings.length > 0) {
//       const matching = data.matchings[0];
//       const routeId = `route-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;

//       // Ensure the route ends exactly at addressEndFlag
//       const routeGeometry = matching.geometry;
//       if (routeGeometry.coordinates.length > 0) {
//         routeGeometry.coordinates[routeGeometry.coordinates.length - 1] = 
//           [addressEndFlag.lng, addressEndFlag.lat];
//       }

//       map.addSource(routeId, {
//         type: 'geojson',
//         data: {
//           type: 'Feature',
//           geometry: routeGeometry
//         }
//       });

//       map.addLayer({
//         id: routeId,
//         type: 'line',
//         source: routeId,
//         layout: {
//           'line-join': 'round',
//           'line-cap': 'round'
//         },
//         paint: {
//           'line-color': '#FFE37E',
//           'line-width': 3,
//           'line-opacity': 0.8
//         }
//       });

//       routeLinesRef.current.push(routeId);
//       return routeGeometry.coordinates;
//     }
//   } catch (error) {
//     console.error('Error creating route:', error);
//   }
//   return [];
// };

// // When map loads, process all routes
// map.on('load', async () => {
//   const clusters = clusterWaypoints(updatedPoints);
//   let allRouteCoords = [];

//   // Process each cluster and collect all route coordinates
//   for (const cluster of clusters) {
//     const routeCoords = await createRoute(cluster);
//     allRouteCoords = [...allRouteCoords, ...routeCoords];
//   }

//   // Add markers only once (start and end)
//   if (allRouteCoords.length > 0) {
//     const startMarker = new mapboxgl.Marker({
//       element: createCustomMarkerElement(start_mark)
//     }).setLngLat([updatedPoints[0].lng, updatedPoints[0].lat]).addTo(map);

//     const endMarker = new mapboxgl.Marker({
//       element: createCustomMarkerElement(end_mark)
//     }).setLngLat([addressEndFlag.lng, addressEndFlag.lat]).addTo(map);

//     markersRef.current.push(startMarker, endMarker);

//     // Fit bounds to the entire route
//     const bounds = allRouteCoords.reduce((bounds, coord) => {
//       return bounds.extend(coord);
//     }, new mapboxgl.LngLatBounds(allRouteCoords[0], allRouteCoords[0]));

//     map.fitBounds(bounds, {
//       padding: 50,
//       maxZoom: 14
//     });
//   }
// });
//     // // Function to create route using Map Matching API
//     // const createRoute = async (points) => {
//     //   try {
//     //     const coordinates = points.map(point => [point.lng, point.lat]).join(';');

//     //     const response = await fetch(
//     //       `https://api.mapbox.com/matching/v5/mapbox/driving/${coordinates}?geometries=geojson&access_token=${mapboxgl.accessToken}`
//     //     );

//     //     const data = await response.json();

//     //     if (data.matchings && data.matchings.length > 0) {
//     //       const matching = data.matchings[0];
//     //       const routeId = `route-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;

//     //       map.addSource(routeId, {
//     //         type: 'geojson',
//     //         data: {
//     //           type: 'Feature',
//     //           geometry: matching.geometry
//     //         }
//     //       });

//     //       map.addLayer({
//     //         id: routeId,
//     //         type: 'line',
//     //         source: routeId,
//     //         layout: {
//     //           'line-join': 'round',
//     //           'line-cap': 'round'
//     //         },
//     //         paint: {
//     //           'line-color': '#FFE37E',
//     //           'line-width': 3,
//     //           'line-opacity': 0.8
//     //         }
//     //       });

//     //       routeLinesRef.current.push(routeId);
//     //       return matching.geometry.coordinates;
//     //     }
//     //   } catch (error) {
//     //     console.error('Error creating route:', error);
//     //   }
//     //   return [];
//     // };

//     // // When map loads, process all routes
//     // map.on('load', async () => {
//     //   const clusters = clusterWaypoints(updatedPoints);
//     //   let allRouteCoords = [];

//     //   // Process each cluster and collect all route coordinates
//     //   for (const cluster of clusters) {
//     //     const routeCoords = await createRoute([...cluster, addressEndFlag]);
//     //     allRouteCoords = [...allRouteCoords, ...routeCoords];
//     //   }

//     //   // Add markers only once (start and end)
//     //   if (allRouteCoords.length > 0) {
//     //     // const startMarker = new mapboxgl.Marker()
//     //     //   .setLngLat([updatedPoints[0].lng, updatedPoints[0].lat])
//     //     //   .addTo(map);

//     //     // const endMarker = new mapboxgl.Marker()
//     //     //   .setLngLat([addressEndFlag.lng, addressEndFlag.lat])
//     //     //   .addTo(map);


//     //       const startMarker = new mapboxgl.Marker({
//     //         element: createCustomMarkerElement(start_mark)
//     //       }).setLngLat([updatedPoints[0].lng, updatedPoints[0].lat]).addTo(map);

//     //       const endMarker = new mapboxgl.Marker({
//     //         element: createCustomMarkerElement(end_mark)
//     //       }).setLngLat([addressEndFlag.lng, addressEndFlag.lat]).addTo(map);


//     //     markersRef.current.push(startMarker, endMarker);

//     //     // Fit bounds to the entire route
//     //     const bounds = allRouteCoords.reduce((bounds, coord) => {
//     //       return bounds.extend(coord);
//     //     }, new mapboxgl.LngLatBounds(allRouteCoords[0], allRouteCoords[0]));

//     //     map.fitBounds(bounds, {
//     //       padding: 50,
//     //       maxZoom: 14
//     //     });
//     //   }
//     // });

//     // Cleanup function
//     return () => {
//       if (mapRef.current) {
//         // Remove all markers
//         markersRef.current.forEach(marker => marker.remove());
//         markersRef.current = [];

//         // Remove all route layers and sources
//         routeLinesRef.current.forEach(id => {
//           if (map.getLayer(id)) map.removeLayer(id);
//           if (map.getSource(id)) map.removeSource(id);
//         });
//         routeLinesRef.current = [];

//         map.remove();
//         mapRef.current = null;
//       }
//     };
//   }, [routeMap, taskAddress]);

//   function createCustomMarkerElement(iconUrl) {
//     const el = document.createElement('div');
//     el.style.backgroundImage = `url(${iconUrl})`;
//     el.style.width = '24px';
//     el.style.height = '24px';
//     el.style.backgroundSize = 'contain';
//     return el;
//   }
//   return (
//     <>
//       {routeMap?.length === 0 ? (
//         <div className='d-flex align-item-center flex-column gap-3 jc-center p-4'>
//           {!showImg && (
//             <Box textAlign='center' className='no-data-found'>
//               <img style={{ maxWidth: '120px' }} src={noDataFound} alt='No Route Found' />
//               <p className='text-12'><strong>No Route Found</strong></p>
//             </Box>
//           )}
//         </div>
//       ) : (
//         <div style={{
//           position: 'relative',
//           width: '100%',
//           height: '100%',
//           borderRadius: '6px',
//           overflow: 'hidden'
//         }}>
//           {(routeMap?.length === 0 || routeMap === undefined) ? '' : (
//             <div
//               ref={mapContainerRef}
//               style={{
//                 width: '100%',
//                 height: route === 'detailRoute' ? '200px' :
//                   route === 'taskRoute' ? '500px' : '300px'
//               }}
//             />
//           )}
//         </div>
//       )}
//     </>
//   );
// };

// export default CalculateMap;
// *********************************************************************************************************map box**********************************************************

import React, { useRef, useEffect } from 'react';
import mapboxgl from 'mapbox-gl';
import 'mapbox-gl/dist/mapbox-gl.css';
import { Box } from '@mui/material';
import start_mark from '../../assets/images/icons/marker/start_mark.svg';
import end_mark from '../../assets/images/icons/marker/end_mark.svg';
import noDataFound from '../../assets/images/nothing-found.svg';
import { useSelector } from 'react-redux';
import { Riple } from 'react-loading-indicators';
// import { routeMap } from 'utilities/common';

// Set your Mapbox access token
mapboxgl.accessToken = process.env.REACT_APP_MAP_KEY_TOKEN;

const CalculateMap = ({ route, taskAddress, showImg, routeMap }) => {
  const mapRef = useRef(null);
  const mapContainerRef = useRef(null);
  const markersRef = useRef([]);
  // taskloading
  const { taskloading = false } = useSelector(state => state.driverAnalyticsHyperDrive);

  useEffect(() => {
    if (!routeMap || routeMap?.length === 0) {
      return;
    }

    const updatedPoints = routeMap?.map(point => ({
      lat: point.latitude,
      lng: point.longitude
    }));

    const addressEndFlag = {
      lat: taskAddress?.latitude,
      lng: taskAddress?.longitude
    };

    // Initialize the map
    const map = new mapboxgl.Map({
      container: mapContainerRef.current,
      style: 'mapbox://styles/mapbox/dark-v10',
      center: [updatedPoints[0].lng, updatedPoints[0].lat],
      zoom: 10
    });

    mapRef.current = map;

    // Add navigation controls
    map.addControl(new mapboxgl.NavigationControl());

    // When map loads, create the route
    map.on('load', () => {
      // Combine all points including the destination
      const allPoints = [...updatedPoints, addressEndFlag];

      // Create a GeoJSON line string
      const routeGeoJSON = {
        type: 'Feature',
        geometry: {
          type: 'LineString',
          coordinates: allPoints.map(point => [point.lng, point.lat])
        },
        properties: {}
      };

      // Add the route source and layer
      map.addSource('route', {
        type: 'geojson',
        data: routeGeoJSON
      });

      map.addLayer({
        id: 'route',
        type: 'line',
        source: 'route',
        layout: {
          'line-join': 'round',
          'line-cap': 'round'
        },
        paint: {
          'line-color': '#FFE37E',
          'line-width': 3,
          'line-opacity': 0.8
        }
      });

      // Add markers
      const startMarker = new mapboxgl.Marker({
        element: createCustomMarkerElement(start_mark)
      }).setLngLat([updatedPoints[0].lng, updatedPoints[0].lat]).addTo(map);

      const endMarker = new mapboxgl.Marker({
        element: createCustomMarkerElement(end_mark)
      }).setLngLat([addressEndFlag.lng, addressEndFlag.lat]).addTo(map);

      markersRef.current.push(startMarker, endMarker);

      // Fit bounds to the entire route
      const bounds = allPoints.reduce((bounds, point) => {
        return bounds.extend([point.lng, point.lat]);
      }, new mapboxgl.LngLatBounds([updatedPoints[0].lng, updatedPoints[0].lat], [updatedPoints[0].lng, updatedPoints[0].lat]));

      map.fitBounds(bounds, {
        padding: 50,
        maxZoom: 14
      });
    });

    // Cleanup function
    return () => {
      if (mapRef.current) {
        // Remove all markers
        markersRef.current.forEach(marker => marker.remove());
        markersRef.current = [];

        // Remove route layer and source if they exist
        if (map.getLayer('route')) map.removeLayer('route');
        if (map.getSource('route')) map.removeSource('route');

        map.remove();
        mapRef.current = null;
      }
    };
  }, [routeMap, taskAddress]);

  function createCustomMarkerElement(iconUrl) {
    const el = document.createElement('div');
    el.style.backgroundImage = `url(${iconUrl})`;
    el.style.width = '24px';
    el.style.height = '24px';
    el.style.backgroundSize = 'contain';
    return el;
  }

  return (
    <>
      {
        taskloading ?
          <div style={{ textAlign: "center" }}>
            <Riple color='#3135cc' size='medium' text='' textColor='' />
          </div>
          :
          <>  {routeMap?.length === 0 ? (
            <div className='d-flex align-item-center flex-column gap-3 jc-center p-4'>
              {!showImg && (
                <Box textAlign='center' className='no-data-found'>
                  <img style={{ maxWidth: '120px' }} src={noDataFound} alt='No Route Found' />
                  <p className='text-12'><strong>No Route Found</strong></p>
                </Box>
              )}
            </div>
          ) : (
            <div style={{
              position: 'relative',
              width: '100%',
              height: '100%',
              borderRadius: '6px',
              overflow: 'hidden'
            }}>
              {(routeMap?.length === 0 || routeMap === undefined) ? '' : (
                <div
                  ref={mapContainerRef}
                  style={{
                    width: '100%',
                    height: route === 'detailRoute' ? '200px' :
                      route === 'taskRoute' ? '500px' : '300px'
                  }}
                />
              )}
            </div>
          )}
          </>
      }

    </>
  );
};

export default CalculateMap;